<!-- Desktop View for Reference Details -->
<div class="row mhide">
 <div class="col-md-12 nopad">
 <div class="card content ">
 <div class=" Head ">
 <div class="card-header d-flex justify-content-between align-items-center">
 <h3>Reference Master</h3>
 <div class="dropdown">
 <button class="dropdown-toggle mhide abutton" type="button" (click)="addReset()" title="Add New">
 <i style="font-size: 19px;" class='bx bx-list-plus'></i> 
 <span>Add New</span>
 </button>
 <a class="dropdown-toggle mshow" (click)="addReset()" data-toggle="tooltip" data-placement="bottom" title="Add New">
 <i class='bx bx-list-plus'></i>
 </a>
 </div>
 </div>
 </div>

 <div class="content_body">
 <div>
 <div class="form-group p-3">
 <label>Reference Type &nbsp;&nbsp;&nbsp;</label>
 <p-dropdown [options]="Type_rows" [(ngModel)]="selectedCar" name="ID" #ID="ngModel" filter="true" (onChange)="onChange(selectedCar)">
 <ng-template let-item pTemplate="selectedItem">
 <span>{{item.label}}</span>
 </ng-template>
 <ng-template let-car pTemplate="item">
 <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
 <div>{{car.label}}</div>
 </div>
 </ng-template>
 </p-dropdown>
 </div>

 <div style="padding-top: 5px">
 <p-table #dt class="table table-striped custom-table" [value]="Rows" [columns]="cols" [paginator]="true" [rows]="10" [resizableColumns]="true" sortMode="multiple" selectionMode="single">
 <ng-template pTemplate="header">
 <tr>
 <th *ngFor="let col of cols" [pSortableColumn]="col.field" width="{{col.width}}">
 {{col.header}}
 <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"></p-sortIcon>
 </th>
 <th width=90>Action</th>
 </tr>
 </ng-template>
 <ng-template pTemplate="body" let-rowData let-car>
 <tr [pSelectableRow]="rowData">
 <td *ngFor="let col of cols">{{car[col.field]}}</td>
 <td class="text-right">
 <a href="javascript:" style="font-size: 18px;padding: 5px" title="Edit" (click)="onEdit(rowData)"><i class="bx bxs-pencil m-r-5"></i></a>
 <a title="Delete" style="font-size: 18px;padding: 5px;color: firebrick" (click)="onDelete(rowData.RGV_iID)"><i class="bx bxs-trash"></i></a>
 </td>
 </tr>
 </ng-template>
 </p-table>
 </div>
 </div>
 <br>
 </div>
 </div>
 </div>
</div>

<!-- Modernized Mobile View for Reference Details -->
<div class="row mshow">
 <!-- Sticky Header -->
 <div class="sticky-header">
 <li (click)="appservice.back()" class="bx bx-left-arrow-alt back-btn"></li>
 <label class="header-title-mobile">Reference Master</label>
 <div class="right-actions-loan">
 <a class="add-btn-round-mini" (click)="addReset()" title="Add Reference">
 <i class='bx bx-plus'></i>
 </a>
 </div>
 </div>

 <div class="col-md-12 nopad mobile-body-report">
 <!-- Reference Type Selection Card -->
 <div class="p-3">
 <div class="report-card-mobile shadow-sm p-3">
 <label class="small-label mb-2">Select Reference Type</label>
 <div class="modern-dropdown-mobile">
 <p-dropdown [options]="Type_rows" [(ngModel)]="selectedCar" filter="true" (onChange)="onChange(selectedCar)" [style]="{'width':'100%', 'border-radius':'10px'}">
 </p-dropdown>
 </div>
 </div>
 </div>

 <!-- Search Card -->
 <div class="px-3">
 <div class="report-card-mobile shadow-sm p-3 mb-0">
 <div class="search-box-mini">
 <i class='bx bx-search'></i>
 <input type="text" (input)="dtMob.filterGlobal($event.target.value, 'contains')" placeholder="Search items...">
 </div>
 </div>
 </div>

 <!-- Results List -->
 <div class="results-grid px-3 pb-5 mt-3">
 <p-table #dtMob [value]="Rows" [globalFilterFields]="['RGV_vCode', 'RGV_vDesciption']">
 <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
 <div class="report-card-mobile shadow-sm mb-3">
 <div class="card-head d-flex justify-content-between align-items-center">
 <span class="loan-no">#{{rowIndex+1}} Code</span>
 <span class="loan-date"><i class='bx bx-hash'></i> {{rowData.RGV_vCode}}</span>
 </div>

 <div class="card-main">
 <div class="customer">{{rowData.RGV_vDesciption}}</div>
 </div>

 <div class="card-footer-mini d-flex justify-content-end align-items-center">
 <div class="d-flex gap-3">
 <button (click)="onEdit(rowData)" class="btn btn-sm btn-outline-primary border-0 p-1">
 <i class='bx bx-edit-alt'></i>
 </button>
 <button (click)="onDelete(rowData.RGV_iID)" class="btn btn-sm btn-outline-danger border-0 p-1">
 <i class='bx bx-trash'></i>
 </button>
 </div>
 </div>
 </div>
 </ng-template>
 </p-table>
 </div>
 </div>

 <!-- Sticky Footer -->
 <div class="mobile-footer-summary sticky-bottom border-top text-center">
 <span class="text-muted small-label">Total Items: <b>{{Rows.length}}</b></span>
 </div>
</div>
